import type { ClassType } from "@vlab-corporation/vlab-pilates-service-interface/branch";

const CLASS_TYPE_LABELS: Record<string, string> = {
  PRIVATE_REGULAR: "1:1 정규",
  PRIVATE_REGULAR_OT: "1:1 OT",
  GROUP_REGULAR: "그룹 정규",
  GROUP_REGULAR_OT: "그룹 OT",
};

interface ClassTypeBadgeProps {
  classType: ClassType | undefined;
  isOt: boolean;
}

export function ClassTypeBadge({ classType, isOt }: ClassTypeBadgeProps) {
  if (!classType) return null;
  const key = isOt ? `${classType}_OT` : classType;
  const label = CLASS_TYPE_LABELS[key] ?? classType;
  return (
    <span className="inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-primary-100 text-primary-700 border border-primary-200">
      {label}
    </span>
  );
}

// Backward compat
export { ClassTypeBadge as ClassFormatSelector };
